const DOCLINKS = {
	TRACES_EXPLORER_EMPTY_STATE:
		'https://signoz.io/docs/instrumentation/overview/?utm_source=product&utm_medium=traces-explorer-empty-state',
	USER_GUIDE: 'https://signoz.io/docs/userguide/',
	TRACES_DETAILS_LINK:
		'https://signoz.io/docs/product-features/trace-explorer/?utm_source=product&utm_medium=traces-explorer-trace-tab#traces-view',
	METRICS_EXPLORER_EMPTY_STATE:
		'https://signoz.io/docs/userguide/send-metrics-cloud/',
	EXTERNAL_API_MONITORING:
		'https://signoz.io/docs/external-api-monitoring/overview/',
};

export default DOCLINKS;
